import { mapTourActiveElementStyles } from 'pages/Map/components/MapTour/MapTour.styled';
import styled, { css } from 'styled-components';

const tourActiveStyles = css`
    ${mapTourActiveElementStyles}
    padding: 1rem;
    transform: translate(1rem, -1rem);
`;

export const ActionsContainer = styled.div<{ isMapTourActiveElement: boolean }>`
    position: absolute;
    z-index: 2;
    top: 5.6rem;
    right: 4rem;
    display: flex;
    flex-direction: column;
    row-gap: 0.8rem;
    @media (max-width: ${({ theme }) => theme.breakpoints.M.min}px) {
        top: 2.4rem;
        right: 2.4rem;
    }
    ${({ isMapTourActiveElement }) => isMapTourActiveElement && tourActiveStyles};
`;

export const ActionsGroup = styled.div`
    display: flex;
    align-self: end;
    flex-direction: column;
    border-radius: 0.8rem;
    background-color: ${({ theme }) => theme.colors.white};
    box-shadow: 0 2px 8px 0 rgba(176, 188, 200, 0.2);
    overflow: hidden;
`;
